
import { City } from '@/common/interface';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BehaviorSubject } from 'rxjs';
import SPUService from '@/services/spu.service';
import { BrandService } from '@/services/brand_service';

interface IApplcableShop {
  id: number;
  shop_name: string;
  poi: string;
  ka: string;
  province: string;
  city: string;
  businessStatus: string;
  checked?: boolean;
}

/** @note 全站已有营业状态枚举值， API要求重造！ */
enum EShopBusinessStatus {
  全部 = -1,
  正常营业 = 0,
  暂停营业 = 1,
  永久停业 = 2,
  惩罚下线 = 3,
}

enum ESelectedStatus {
  全部 = 0,
  选中 = 1,
  未选中 = 2,
}

@Component({})
export default class albumLookShops extends Vue {
  loading = false;

  isVisible = false;

  businessStatusEnum = EShopBusinessStatus;

  ESelectedStatus = ESelectedStatus;

  initFormValue = {
    shop_name: '',
    regionId: '',
    provinceId: '',
    ka: '',
    id: '',
    businessStatus: EShopBusinessStatus.全部,
    poi: '',
    selectedStataus: ESelectedStatus.全部,
    onsite_service: undefined,
  };

  form: {
    regionId: number | string;
    provinceId: number | string;
    id: number | string;
    ka: string;
    businessStatus: EShopBusinessStatus;
    shop_name: string;
    poi: string;
    selectedStataus: ESelectedStatus;
    onsite_service: any;
  } = { ...this.initFormValue };

  template_id: any = '';

  businessStatusList: EShopBusinessStatus[] = [
    EShopBusinessStatus.全部,
    EShopBusinessStatus.正常营业,
    EShopBusinessStatus.暂停营业,
    EShopBusinessStatus.永久停业,
    EShopBusinessStatus.惩罚下线,
  ];

  selectedStatausList: ESelectedStatus[] = [
    ESelectedStatus.全部,
    ESelectedStatus.选中,
    ESelectedStatus.未选中,
  ];

  onsiteServiceList: any[] = [
    {
      label: '是',
      value: 1,
    },
    {
      label: '否',
      value: 0,
    },
  ];

  kaList: Array<{ key: string; val: number }> = [];

  kaListMap = new Map<string | number, string | number>();

  citys: City[] = [];

  regions: Array<{ city: City[]; id: number; name: string }> = [];

  columns = [
    {
      title: '门店ID',
      dataIndex: 'shop_id',
      key: 'shop_id',
      width: 80,
      align: 'center',
    },
    {
      title: 'POIID',
      dataIndex: 'poi',
      key: 'poi',
      width: 80,
      align: 'center',
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      width: 200,
      align: 'center',
    },
    {
      title: '省份',
      dataIndex: 'province',
      key: 'province',
      width: 80,
      align: 'center',
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      width: 80,
      align: 'center',
    },
    {
      title: '营业状态',
      dataIndex: 'businessStatus',
      key: 'businessStatus',
      width: 80,
      align: 'center',
    },
    {
      title: '上门服务',
      dataIndex: 'onsiteServiceFlag',
      key: 'onsiteServiceFlag',
      width: 80,
      align: 'center',
      customRender: (val: any) => {
        return val ? '是' : '否';
      },
    },
  ];

  $listData = new BehaviorSubject([]);

  listData: IApplcableShop[] = [];

  pagination = {
    total: 0,
    pageSize: 50,
    current: 1,
    pageSizeOptions: ['10', '20', '50', '100', '200'],
    showSizeChanger: true,
    showTotal: () => {
      return `总数：${this.pagination.total}`;
    },
    onChange: this.paginationChange,
    onShowSizeChange: this.paginationSizeChange,
  };

  selectedIds = '';

  removeIds: number[] = [];

  addIds: number[] = [];

  selectedRowKeys: number[] = [];

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(SPUService)
  protected spuService!: SPUService;


  @lazyInject(BrandService)
  protected brandService!: BrandService;

  @Prop()
  ids?: string;

  @Prop()
  spuType!: 'spu' | 'platformSpu' | 'kaSpu' | 'leadingSpu';

  // @Watch('ids', { deep: true })
  // watchIds() {
  //   if (this.ids && this.ids !== '') {
  //     this.selectedIds = this.ids;
  //     const selectedRowKeys = this.ids.split(',').map((item) => {
  //       return Number(item);
  //     });
  //     this.selectedRowKeys = [...selectedRowKeys];
  //   }
  // }

  filterByProvinceId() {
    if (Number(this.form.provinceId) < 0) {
      return [];
    } else {
      for (const idx of this.regions) {
        if (Number(this.form.provinceId) === idx.id) {
          return idx.city;
        }
      }
    }
  }

  async fetchKas() {
    if (this.spuType === 'leadingSpu') {
      return this.spuService.leadingSpuKas();
    } else if (this.spuType === 'kaSpu') {
      return this.spuService.kaSpuKas();
    }
  }

  async getKaList() {
    const res = await this.fetchKas();
    if (res && res.length) {
      this.kaList = [...res];

      const map = new Map<string | number, string | number>();
      for (const item of res) {
        const { key, val } = item;
        map.set(key, val);
        map.set(val, key);
      }
      if (map.size) {
        this.kaListMap = new Map(map);
      }
    }
  }

  onChangeProvince(val: number) {
    this.$set(this.form, 'regionId', '');
    if (val !== undefined) {
      this.$set(this.form, 'provinceId', val);
    }
  }

  diff(original: number[], current: number[]) {
    const intersection = current.filter((item) => original.indexOf(item) > -1);
    const toAdd = current.filter((item) => intersection.indexOf(item) === -1);
    return ([] as number[]).concat(intersection, toAdd);
  }

  handleRowChange(selectedRowKeys: number[]) {
    const newKeys = this.diff(this.selectedRowKeys, selectedRowKeys);
    this.selectedRowKeys = [...newKeys];
  }

  getCheckboxProps(record: IApplcableShop) {
    return {
      props: {
        checked: this.selectedRowKeys.includes(record.id),
      },
    };
  }

  resetForm() {
    this.form = { ...this.initFormValue };
  }

  resetPagination() {
    Object.assign(this.pagination, {
      total: 0,
      pageSize: 50,
      current: 1,
    });
  }

  /** 获取城市里列表 */
  async getCityList() {
    const response = (await this.shopService.getCityList()) as unknown as {
      [key: string]: {
        province: City;
        city: City[];
      };
    };
    if (response) {
      const citys = Object.values(response)
        .map((item) => item.city)
        .reduce((prev, cur) => prev.concat(cur), []);
      this.citys = citys;

      const all = Object.values(response);
      const list: Array<{ id: number; name: string; city: City[] }> = [];
      for (const province of all) {
        list.push({
          city: province.city,
          id: province.province ? province.province.id : 0,
          name: province.province ? province.province.name : '直辖市',
        });
      }
      this.regions = [...list];
    } else {
      this.citys = [];
    }
  }

  /** 省市过滤 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  /** KA 品牌过滤 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  kaFilterOption(input: any, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }

  async search() {
    this.resetPagination();
    const {
      poi,
      provinceId,
      shop_name,
      ka,
      businessStatus,
      id,
      regionId,
      selectedStataus,
      onsite_service,
    } = this.form;
    const reqParam: {
      pageSize: number;
      page: number;
      regionId?: number | string;
      provinceId?: number | string;
      id?: number | string;
      ka?: string;
      businessStatus?: EShopBusinessStatus;
      selectedStatus?: ESelectedStatus;
      shop_name?: string;
      poi?: string;
      template_id?: string;
      onsite_service?: string;
    } = {
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
      template_id: this.template_id,
    };

    if (poi) {
      reqParam.poi = poi;
    }
    if (shop_name) {
      reqParam.shop_name = shop_name;
    }
    if (ka) {
      reqParam.ka = ka;
    }
    if (id) {
      reqParam.id = id;
    }
    if (regionId) {
      reqParam.regionId = regionId;
    }
    if (provinceId && (!regionId || regionId === '')) {
      reqParam.provinceId = provinceId;
    }

    if (businessStatus !== EShopBusinessStatus.全部) {
      reqParam.businessStatus = businessStatus;
    }
    if (selectedStataus !== ESelectedStatus.全部) {
      reqParam.selectedStatus = selectedStataus;
    }
   if (onsite_service !== '' && onsite_service !== undefined) {
      reqParam.onsite_service = onsite_service;
    }
    if (this.template_id !== '') {
      reqParam.template_id = this.template_id;
    }
    await this.list(reqParam);
  }


  async list(reqParam: {
    pageSize: number;
    page: number;
    regionId?: number | string;
    provinceId?: number | string;
    id?: number | string;
    ka?: string;
    businessStatus?: EShopBusinessStatus;
    shop_name?: string;
    poi?: string;
    selectedStatus?: ESelectedStatus;
    template_id?: string;
    onsite_service?: string;
  }) {
    const {
      regionId,
      provinceId,
      id,
      ka,
      businessStatus,
      shop_name,
      poi,
      template_id,
      onsite_service,
    } = reqParam;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params: any = {
      pageSize: reqParam.pageSize,
      page: reqParam.page,
      pick: 0,
    };
    if (id) {
      params.shop_id = id;
    }
    if (shop_name) {
      params.shop_name = shop_name;
    }
    if (ka) {
      params.ka = ka;
    }
    if (poi) {
      params.poi = poi;
    }
    if (typeof provinceId !== 'undefined') {
      params.provinceId = provinceId;
    }
    if (typeof regionId !== 'undefined') {
      params.regionId = regionId;
    }
    if (typeof businessStatus !== 'undefined') {
      params.businessStatus = businessStatus;
    }
    params.pick = 1;
    if (typeof template_id !== 'undefined') {
      params.template_id = template_id;
    }
    if (typeof onsite_service !== 'undefined') {
      params.onsite_service = onsite_service;
    }
     params.template_id = this.template_id;
    // console.log(params);
    const res = await this.brandService.brandAlbumKaTemplateShopList(params);

    if (res) {
      const list: IApplcableShop[] = res.list.map((item: any) => {
        const cityTarget = this.citys.find((city) => city.id === item.regionid);
        const provinceTarget =
          this.regions.find((province) => province.id === item.regionpid) ||
          this.citys.find((city) => city.id === item.regionpid);
        return {
          shop_name: item.shop_name,
          shop_id: item.shop_id,
          poi: item.poi,
          id: item.AutoRepairShopDataId,
          ka: `${this.kaListMap.get(item.ka_id) || '--'} `,
          businessStatus: EShopBusinessStatus[item.onlinestatus],
          city: cityTarget ? cityTarget.name : '--',
          province: provinceTarget ? provinceTarget.name : '--',
          onsiteServiceFlag: item.onsite_service_flag,
        };
      });

      this.listData = [...list];

      Object.assign(this.pagination, {
        total: res.total,
        pageSize: +res.pageSize,
        current: res.page,
      });
    }
  }

  onChangeKa(val: number | string) {
    const idx = this.kaList?.findIndex((item) => item.val === val);

    if (this.kaList && typeof idx !== 'undefined' && idx > -1) {
      const targert = this.kaList[idx];
      this.$set(this.form, 'ka', targert.val);
    }
  }

  async paginationChange(current: number) {
    this.pagination.current = current;
    const reqParam: {
      pageSize: number;
      page: number;
      regionId?: number | string;
      id?: number | string;
      ka?: string;
      businessStatus?: EShopBusinessStatus;
      selectedStatus?: ESelectedStatus;
      shop_name?: string;
      poi?: string;
      template_id?: string;
      onsite_service?: string;
    } = {
      pageSize: this.pagination.pageSize,
      page: current,
      template_id: this.template_id,
    };
    const { id, shop_name, poi, ka, regionId, businessStatus, selectedStataus, onsite_service } =
      this.form;
    if (id) {
      reqParam.id = id;
    }
    if (shop_name) {
      reqParam.shop_name = shop_name;
    }
    if (poi) {
      reqParam.poi = poi;
    }
    if (ka) {
      reqParam.ka = ka;
    }
    if (regionId) {
      reqParam.regionId = regionId;
    }
    if (businessStatus !== EShopBusinessStatus.全部) {
      reqParam.businessStatus = businessStatus;
    }
    if (selectedStataus !== ESelectedStatus.全部) {
      reqParam.selectedStatus = selectedStataus;
    }
    if (onsite_service) {
      reqParam.onsite_service = onsite_service;
    }
    if (this.ids !== '') {
      reqParam.template_id = this.ids;
    }

    await this.list(reqParam);
  }

  async paginationSizeChange(current: number, size: number) {
    this.$set(this.pagination, 'pageSize', size);
    // 重置每页显示数目后，默认重新刷新第1页
    await this.paginationChange(1);
  }

  async open(data: any) {
    this.template_id = data.template_id;
    // console.log(shopIds);
    // this.watchIds();
    this.isVisible = true;
    await this.list({
      template_id: data.template_id,
      pageSize: this.pagination.pageSize,
      page: this.pagination.current,
    });
  }

  close() {
    this.isVisible = false;
    this.reset();
  }

  save() {
    this.$emit('save', this.selectedRowKeys.join(','));
    this.close();
  }

  reset() {
    this.resetForm();
    this.resetPagination();
    this.selectedIds = '';
    this.removeIds = [];
    this.addIds = [];
    this.selectedRowKeys = [];
    this.listData = [] as IApplcableShop[];
  }

  async mounted() {
    await this.getCityList();
    await this.getKaList();
  }
}
